<template>
    <el-dialog :title="dialogData.title" :visible.sync="showTip" :modal-append-to-body="false" :close-on-click-modal="false" width="40%"
               :before-close="handleClose" v-loading="pageLoading">
        <!-- <div class="tip">提示:处理方式为“未发现问题“或”已补传记录“，该预警的扣分会清零。处理方式为“确认存在问题”的情况下，可更改扣分分值。</div> -->
        <el-form :model="form" label-width="100px" :rules="rules" ref="ruleForm">
            <el-form-item label="处理方式" prop="handleType">
                <el-select v-model="form.handleType" placeholder="请选择处理方式" clearable>
                    <el-option v-for="item in handle" :key="item.key" :label="item.value" :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="处理人" prop="handlePersonName">
                <el-input v-model="form.handlePersonName" placeholder="请输入处理人" clearable style="width: 60%"></el-input>
            </el-form-item>
            <el-form-item label="处理备注" prop="handleRemark">
                <el-input type="textarea" placeholder="请输入处理备注, 300字以内, 选填" :autosize="{minRows: 12, maxRows: 15}" maxlength="300"
                          v-model="form.handleRemark" style="width: 60%;"></el-input>
                <span class="tipText">(选填)</span>
            </el-form-item>
            <el-form-item label="处理附件" prop="handleRemark">
                <xcwsUpload :maxLength=3 @uploadSuccess='getFiles' @uploadError="getFiles" @remove='getFiles' :filesArr='detailFilesArr'></xcwsUpload>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button :disabled="btn" type="primary" @click="comfirmAdd">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as api from 'api/warning_v2.js';
import xcwsUpload from "components/ybUpload";
export default {
    name: "disposeDialog",
    components: {
        xcwsUpload
    },
    props: {
        showTip: {
            type: Boolean,
            default: true
        },
        dialogData: {
            type: Object,
        },
        url: {
            type: String
        },
        disposeType: {
            type: String,
            default: '01'
        },
        handle: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        schoolTraceBaseUrl() {
            return this.$store.state.common.baseUrl
        },
    },
    data() {
        return {
            pageLoading: false,
            detailFilesArr: [],
            btn: false,
            submitUrl: '',
            form: {
                handlePersonName: '',
                handleType: '',
                // handleDeduction: 0,
                handleDept: "ENTITY",
                handleRemark: '',
                warningId: '',
                fidList: [],
            },
            fidList: [],
            formId: '',
            grade: [],
            rules: {
                handlePersonName: [{
                    required: true,
                    message: '请输入处理人',
                    trigger: 'blur'
                },],
                handleType: [{
                    required: true,
                    message: '请选择处理方式',
                    trigger: 'change'
                }],
                handleRemark: [{
                    min: 0,
                    max: 300,
                    message: '请输入300字以内的备注',
                    trigger: 'blur'
                }],
            }
        }
    },
    mounted() {
        this.form.warningId = this.dialogData.warningId;
        this.form.handleStatus = this.dialogData.handleStatus;
        this.submitUrl = this.url;
        if (this.dialogData.warningId && this.dialogData.title == '重新处理') {
            this.pageLoading = true;
            api.getRecordBack({ id: this.form.warningId })
                .then(data => {
                    if (data.code == 200) {
                        Object.assign(this.form, data.data);
                        this.form.id = data.data.id;
                        this.fidList = data.data.files
                        this.detailFilesArr = data.data.files.map(item => {
                            return {
                                ...item,
                                url: this.schoolTraceBaseUrl + "/" + item.fileUrl,
                            }
                        })
                    }
                })
                .finally(() => this.pageLoading = false)
        }
    },
    methods: {
        getFiles(files, state) {
            this.fidList = files;
        },
        cancel() {
            this.$emit("cancel")
        },
        refreshList() {
            this.$emit("refresh")
        },
        async comfirmAdd() {
            this.btn = true;
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    this.form.fidList = this.fidList.map(item => item.fileId)
                    let data = {
                        "fileList": this.form.fidList,
                        "handlePersonName": this.form.handlePersonName,
                        "handleRemark": this.form.handleRemark,
                        "handleType": this.form.handleType,
                        "warningId": this.form.warningId,
                        "handleDept": 'ENTITY',
                        "handleDeduction": this.form.handleDeduction,
                    }

                    let result = await api.setHandle(data, this.submitUrl);
                    if (result.code == '200') {
                        this.$message({ message: '处理成功', type: 'success' });
                        this.cancel();
                        this.refreshList();
                        this.btn = false;
                    } else {
                        this.btn = false;
                    }
                } else {
                    this.btn = false;
                    return false;
                }
            });
        },
        handleClose() {
            this.$emit("cancel")
        },
    }
}
</script>

<style scoped lang="scss">
.tip {
    width: 95%;
    margin: 0 auto 30px auto;
    background: rgba(255, 243, 233, 1);
    border: 1px solid rgba(255, 214, 182, 1);
    color: #f1822a;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    padding: 10px 20px;
    box-sizing: border-box;
}

.tipText {
    color: #a2aab6;
    font-size: 12px;
    line-height: 17px;
    font-weight: 400;
    margin-left: 6px;
}
</style>
